@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.target-icon {
  background-color: @third-pdo--icon--background-color;
  border: none;

  > svg {
    height: 20px;
    width: 20px;
    color: @third-pdo--icon--text-color;
    margin-top: 3px;
  }
  padding-left: 5px;
  &:hover {
    cursor: pointer;
  }
}
